import { api } from '@/fsd/shared/api';

interface IUpdatedApi {
  id: number;
  inn?: string;
  name?: string;
}

interface IUpdatedApiResult {
  message: string;
  data: object;
}

export const putOrganizationV2 = async (
  updatedApi: IUpdatedApi
): Promise<IUpdatedApiResult | undefined> => {
  const data = await api.put<IUpdatedApiResult>(`/api/v2/organisation/`, {
    body: {
      id: updatedApi.id,
      inn: updatedApi.inn,
      name: updatedApi.name,
    },
  });

  return data;
};
